import React from 'react';

import { UILabPage } from './UILabPage';

import { Button, ButtonTheme, ButtonModifiers } from '@components/Button';
import { Badge, BadgeThemes } from '@components/Badge/Badge';
import { Input } from '@components/Input';
import { Select } from '@components/Select';

export interface UILabComponent {
    id: string;
    title: string;
    url: string;
    Component: React.ComponentType<any>;
    fields?: {
        themes: any[];
        modifiers: any[];
    };
    componentProps?: any[];
}

class Component extends React.Component {
    public render(): React.ReactNode {
        return React.createElement(UILabPage, {
            componentList: this.makeComponents(),
        });
    }

    public makeComponents() {
        return [
            {
                id: 'uilab-button',
                title: 'Button',
                url: '/button',
                Component: Button,
                fields: {
                    themes: [
                        {
                            theme: ButtonTheme.Primary,
                            children: 'Primary',
                        },
                        {
                            theme: ButtonTheme.Secondary,
                            children: 'Secondary',
                        },
                        {
                            theme: ButtonTheme.Gradient,
                            children: 'Gradient',
                        },
                        {
                            theme: ButtonTheme.Light,
                            children: 'Light',
                        },
                        {
                            theme: ButtonTheme.Danger,
                            children: 'Danger',
                        },
                        {
                            theme: ButtonTheme.Light,
                            children: 'LightRedesign',
                        },
                        {
                            theme: ButtonTheme.Link,
                            children: 'Link',
                        },
                        {
                            theme: ButtonTheme.Link,
                            children: 'LinkRedesign',
                        },
                        {
                            theme: ButtonTheme.Main,
                            children: 'Main',
                        },
                        {
                            theme: ButtonTheme.SecondaryLightHover,
                            children: 'SecondaryLightHover',
                        },
                        {
                            theme: ButtonTheme.White,
                            children: 'White',
                        },
                    ],
                    modifiers: [
                        {
                            theme: ButtonTheme.Primary,
                            modifiers: [ButtonModifiers.Big],
                            children: 'Big',
                        },
                        {
                            theme: ButtonTheme.Primary,
                            modifiers: [ButtonModifiers.MobilePaddings],
                            children: 'MobilePaddings',
                        },
                        {
                            theme: ButtonTheme.Primary,
                            modifiers: [ButtonModifiers.Small],
                            children: 'Small',
                        },
                    ],
                },
            },
            {
                id: 'uilab-badge',
                title: 'Badge',
                url: '/button',
                Component: Badge,
                componentProps: [
                    {
                        text: 'Badge',
                        theme: BadgeThemes.WARN,
                    },
                ],
            },
            {
                id: 'uilab-input',
                title: 'Input',
                url: '/input',
                Component: Input,
                componentProps: [
                    {
                        value: 'Input value',
                        title: 'Input title',
                    },
                ],
            },
            {
                id: 'uilab-select',
                title: 'Select',
                url: '/select',
                Component: Select,
                componentProps: [
                    {
                        onChange: () => {},
                    },
                ],
            },
        ];
    }
}

export const UILabPageContainer = Component;
